// Routing decisions around the water serviceability step

import type { PropertyData } from '@/types/property';

// Vendors whose orders proceed directly without the
// "Great news! Water service is available" confirmation screen.
// Dev and prod APIs return different vendor names for Dallas.
const SKIP_SERVICE_AVAILABLE_VENDORS = ['dallas, tx', 'city of dallas, tx'];

export function skipsServiceAvailableScreen(vendorName?: string | null): boolean {
  if (!vendorName) return false;
  return SKIP_SERVICE_AVAILABLE_VENDORS.includes(vendorName.trim().toLowerCase());
}

// Show the property confirmation screen only when we have meaningful
// property data, and never for apartments/condos.
export function shouldShowPropertyScreen(propertyData?: PropertyData | null): boolean {
  if (!propertyData) return false;

  const hasValidPropertyData = !!(
    propertyData.squareFootage ||
    propertyData.bedrooms ||
    propertyData.bathrooms ||
    propertyData.yearBuilt
  );

  const propertyType = propertyData.propertyType?.toLowerCase() || '';
  const isApartmentType = propertyType.includes('apartment') || propertyType.includes('condo');

  return hasValidPropertyData && !isApartmentType;
}
